export class ViewManager {
  static show(viewId) {
    document.querySelectorAll('.view').forEach(view => {
      view.classList.remove('active');
    });
    
    const targetView = document.getElementById(viewId);
    if (targetView) {
      targetView.classList.add('active');
    } else {
      console.warn(`View with id "${viewId}" not found`);
    }
  }

  static getCurrentView() {
    const activeView = document.querySelector('.view.active');
    return activeView ? activeView.id : null;
  }
}
